"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchPickupPointDeliveryOptionsPath = exports.searchPickupPointDeliveryOptions = void 0;
const utils_1 = require("@invivodf/utils");
const utils_2 = require("../../../utils");
const searchPickupPointDeliveryOptions = (client) => async ({ checkoutId, consignmentId, addressId, logisticOfferId }) => {
    try {
        const response = await client.post((0, exports.searchPickupPointDeliveryOptionsPath)(checkoutId, consignmentId), {
            addressId,
            logisticOfferId
        });
        return utils_1.Result.success(response.data);
    }
    catch (error) {
        if ((0, utils_2.isFunctionalApiError)(error)) {
            return utils_1.Result.failure({
                code: error.body.code,
                message: error.body.message
            });
        }
        throw error;
    }
};
exports.searchPickupPointDeliveryOptions = searchPickupPointDeliveryOptions;
const searchPickupPointDeliveryOptionsPath = (checkoutId, consignmentId) => `/v2/bff/appro/checkouts/${checkoutId}/consignments/${consignmentId}/pickup-point-options/search`;
exports.searchPickupPointDeliveryOptionsPath = searchPickupPointDeliveryOptionsPath;
